import { takeEvery, call, put } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import { updateLink, errorLink, LINK_POST } from 'actions/link'
import { updateUserData } from 'actions/general'
import { logInteraction } from 'util/log-interaction'

function _postLink({ create }, logError) {
  return function*(action) {
    try {
      logInteraction('link')
      const accountEndpoint = '/auth/external/link'

      const values = action.payload.values

      const linkResult = yield call(create, accountEndpoint, values)
      const { orgslug } = linkResult

      yield put(
        updateLink({
          data: linkResult,
        })
      )
      yield put(
        updateUserData({
          orgslug,
          username: values.username,
          portalUrl: linkResult.returnTo,
        })
      )

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data = err.responseText ? JSON.parse(err.responseText) : null
      const errorData = data.error

      if (errorData) {
        yield call(
          action.payload.reject,
          new SubmissionError({ _error: errorData })
        )
      } else {
        yield call(action.payload.reject)
      }

      yield put(
        errorLink({
          error: true,
          data: data,
        })
      )
    }
  }
}

export const Test = {
  _postLink,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchPostLink(api, error) {
  yield takeEvery(LINK_POST, _postLink(api, error))
}
